import { FC, Fragment } from 'react'
import ApplicationsList from '.'
import i18n from '../../../translations/i18n'
import { Application } from '../../../types/applications'
import Dialog from '../../Dialog'

interface ApplicationsDialogProps {
  applications: Application[]
  t: i18n.TFunction
  apartmentAddress: string | undefined
}

const ApplicationsDialog: FC<ApplicationsDialogProps> = ({
  applications,
  t,
  apartmentAddress
}) => {
  const title = t('adminApartments.actions.manageApplications')
  return (
    <Dialog
      dialogId='manageApplications'
      title={`${title} (${apartmentAddress})`}
      buttonLabel={title}
      color='primary'
      variant='contained'
      maxWidth='md'
      onlyCloseButton={true}
      Content={
        <Fragment>
          <ApplicationsList applications={applications} t={t} />
        </Fragment>
      }
    />
  )
}

export default ApplicationsDialog
